<template>
  <div class="filter-multiple">
    <template>
      <div class="filter-multiple-section">
        <span class="filter-label">{{ $t('src/components/coursesettingsblock.importance') }}</span>
        <div class="d-flex mt-2 ml-2">
          <div
            v-for="item in importanceEvents"
            :key="item"
            class="border-square"
            :class="{ active: isSelectedSquare(item) }"
          >
            <div class="square" :class="'square-' + item" @click="selectImportance(item)"></div>
          </div>
        </div>
      </div>
      <div class="canvas"></div>
      <div class="filter-multiple-section mb-2 filter-label">
        {{ $t('src/components/coursesettingsblock.cardioEvents') }}
      </div>
    </template>
    <div
      v-for="event in eventsList"
      :key="event.type"
      class="filter-multiple__item filter-multiple__narrow container"
      :class="{ active: isSelected(event.type) }"
      @click="selectEvent(event.type)"
    >
      <div class="row">
        <div class="col-10">
          <span class="dot" :class="event.color ? 'dot-' + event.color : 'dot'">●</span>
          {{ event.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventsConfig } from '@/events.config.js'
import('@/styles/components/filter.less')
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'CardioEventsFilterInMultitraining',
  model: {
    prop: 'selectedEvents'
  },
  props: {
    noFilterSpecified: {
      type: Boolean,
      required: true
    },
    selectedEvents: {
      type: Array,
      required: true
    },
    selectedImportance: {
      type: Array,
      required: false
    }
  },
  data: () => ({
    isShow: false,
    eventsList: null,
    localSelected: [],
    localImportance: [],
    importanceEvents: ['danger', 'warning', 'secondary', 'primary']
  }),
  computed: {},
  mounted() {
    this.localImportance = this.selectedImportance ? this.selectedImportance : this.importanceEvents
    this.addEventsToList()
    if (this.noFilterSpecified) {
      this.eventsList.forEach(event => {
        if (!this.localSelected.includes(event.type)) {
          this.localSelected.push(event.type)
        }
      })
      this.$emit('set:events', this.localSelected)
    } else {
      this.localSelected = cloneDeep(this.selectedEvents)
    }
  },
  methods: {
    selectEvent(type) {
      let pos = this.localSelected.indexOf(type)
      if (pos === -1) {
        this.localSelected.push(type)
      } else {
        this.localSelected.splice(pos, 1)
      }
      let selectedColor = this.eventsList.find(item => {
        return item.type === type
      }).color
      let eventIsSelectedColor = this.localSelected.find(event => {
        let eventInfoObject = this.eventsList.find(item => {
          return item.type === event
        })
        return eventInfoObject.color === selectedColor
      })
      if (!eventIsSelectedColor) {
        this.selectImportance(selectedColor)
      } else {
        let pos = this.localImportance.indexOf(selectedColor)
        if (pos === -1) {
          this.localImportance.push(selectedColor)
        } else {
          this.$emit('set:events', this.localSelected)
        }
      }
    },
    selectImportance(item) {
      let pos = this.localImportance.indexOf(item)
      if (pos === -1) {
        this.localImportance.push(item)
      } else {
        this.localImportance.splice(pos, 1)
      }
      this.localSelected = []
      this.eventsList.forEach(event => {
        if (this.localImportance.includes(event.color)) {
          this.localSelected.push(event.type)
        }
      }, this)
      this.$emit('set:events', this.localSelected)
      this.$emit('input:importance', this.localImportance)
    },
    isSelected(type) {
      return this.localSelected && this.localSelected.indexOf(type) !== -1
    },
    isSelectedSquare(item) {
      return this.localImportance && this.localImportance.indexOf(item) !== -1
    },
    addEventsToList() {
      let res = []
      Object.keys(eventsConfig).forEach(key => {
        if (key !== 'break' && key !== 'reconnected') {
          const event = eventsConfig[key]
          event.type = key
          res.push(event)
        }
      })
      this.eventsList = this.sortArray(res)
    },
    sortArray(array) {
      let danger = [],
        warning = [],
        primary = [],
        secondary = []

      array.forEach(element => {
        if (this.importanceEvents.indexOf(element.color) !== -1) {
          switch (element.color) {
            case 'warning':
              warning.push(element)
              break
            case 'primary':
              primary.push(element)
              break
            case 'secondary':
              secondary.push(element)
              break
            default:
              danger.push(element)
              break
          }
        }
      }, this)

      let sorted = []
      sorted.push(...danger, ...warning, ...secondary, ...primary)
      return sorted
    }
  }
}
</script>
